const breakpoints = {
  bpPhonePx: '480px',
  bpTabletPx: '720px',
  bpLaptopPx: '1024px',
  bpDesktopPx: '1200px',
  contentWrap: '1140px',
  contentWrapLarge: '1720px'
}

export default breakpoints
